import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AbstractService } from './abstract.service';

export interface UsoCliente {
  cnpj: string;
  nome?: string;
  registroId?: number;
  limite: number;
  total: number;
  quantidade: number;
  ultimo?: string;
}

export interface PastaArquivos {
  pasta: string;
  quantidade: number;
  total: number;
  ultimo?: string;
}

export interface ResumoArquivos {
  tenant: string;
  total: number;
  quantidade: number;
  ultimo?: string;
  pastas: PastaArquivos[];
}

export interface ArquivoCliente {
  id: number;
  createdAt: string;
  empresa: number;
  user: number;
  filename: string;
  s3Filename: string;
  size: number;
  isPrivate: boolean;
  pasta: string;
}

export interface FiltroArquivos {
  pasta?: string;
  busca?: string;
  ordem?: string;
  inicio?: number;
  quantidade?: number;
}

export function formataBytes(bytes: number): string {
  const valor = Number(bytes) || 0;
  if (valor < 1000) {
    return valor + ' B';
  }
  const unidades = ['KB', 'MB', 'GB', 'TB'];
  let atual = valor / 1000;
  let i = 0;
  while (atual >= 1000 && i < unidades.length - 1) {
    atual = atual / 1000;
    i++;
  }
  return atual.toLocaleString('pt-BR', { maximumFractionDigits: atual < 10 ? 2 : 1 }) + ' ' + unidades[i];
}

export function nomePasta(pasta: string): string {
  switch (pasta) {
    case 'anexos': return 'Anexos';
    case 'imagens': return 'Imagens';
    case 'certificados': return 'Certificados';
    case 'habil-fiscal': return 'Notas fiscais (XML/PDF)';
    case 'central-relatorios': return 'Relatórios';
    default: return pasta || 'Outros';
  }
}

@Injectable({
  providedIn: 'root',
})
export class ArmazenamentoClientesService {
  constructor(private http: HttpClient) {}

  clientes(): Observable<UsoCliente[]> {
    return this.http.get<UsoCliente[]>(this.url('clientes'), { headers: this.headers() });
  }

  resumo(cnpj: string): Observable<ResumoArquivos> {
    return this.http.get<ResumoArquivos>(this.url(`clientes/${cnpj}/resumo`), { headers: this.headers() });
  }

  arquivos(cnpj: string, filtro: FiltroArquivos): Observable<{ total: number; registros: ArquivoCliente[] }> {
    let params = new HttpParams();
    Object.keys(filtro).forEach((k) => {
      const v = (filtro as any)[k];
      if (v !== undefined && v !== null && v !== '') {
        params = params.set(k, String(v));
      }
    });
    return this.http.get<{ total: number; registros: ArquivoCliente[] }>(this.url(`clientes/${cnpj}/arquivos`), { headers: this.headers(), params });
  }

  urlArquivo(cnpj: string, filename: string): Observable<{ url: string }> {
    const params = new HttpParams().set('filename', filename);
    return this.http.get<{ url: string }>(this.url(`clientes/${cnpj}/url`), { headers: this.headers(), params });
  }

  salvarLimite(cnpj: string, limite: number): Observable<{ cnpj: string; limite: number }> {
    return this.http.put<{ cnpj: string; limite: number }>(this.url(`clientes/${cnpj}/limite`), { limite }, { headers: this.headers() });
  }

  private url(caminho: string): string {
    return environment.api + '/admin/armazenamento/' + caminho;
  }

  private headers(): HttpHeaders {
    return new HttpHeaders({
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json',
      'X-Auth-Token': AbstractService.token(),
    });
  }
}
